import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { translate } from "../../../Services/translation";
import { setAlgoliaSearchQuery } from "../../../Actions/AlgoliaSearch.action";

function CustomSearchBox() {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const { algoliaQuery } = useSelector((state) => state.algoliaSearch);

  useEffect(() => {
    setInputValue(algoliaQuery);
  }, [algoliaQuery]);

  const setQuery = (newQuery: string) => {
    setInputValue(newQuery);
    dispatch(setAlgoliaSearchQuery(newQuery));
  };

  return (
    <div className="ais-SearchBox">
      <form
        className="ais-SearchBox-form"
        action=""
        role="search"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();

          if (inputRef.current) {
            inputRef.current.blur();
          }
        }}
        onReset={(event) => {
          event.preventDefault();
          event.stopPropagation();

          setQuery("");

          if (inputRef.current) {
            inputRef.current.focus();
          }
        }}
      >
        <input
          ref={inputRef}
          className="ais-SearchBox-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          maxLength={512}
          type="search"
          value={inputValue}
          onChange={(event) => {
            setQuery(event.currentTarget.value);
          }}
          autoFocus
        />
        <button
          type="submit"
          title={translate("algolia.searchbox.submit")}
          className="ais-SearchBox-submit"
        >
          <i className="icon-search"></i>
        </button>
        <button
          type="reset"
          title={translate("algolia.searchbox.reset")}
          hidden={!inputValue}
          className="ais-SearchBox-reset"
        >
          <i className="ph-x"></i>
        </button>
      </form>
    </div>
  );
}

export default CustomSearchBox;
